// Gráfico de evolución en SVG puro (ligero, sin librerías pesadas).
export function EvolutionChart({ data }) {
    const W = 640;
    const H = 200;
    const pad = 28;
    if (!data || data.length === 0) return null;

    const points = data.map((d, i) => ({
        x: data.length === 1 ? W / 2 : pad + (i * (W - pad * 2)) / (data.length - 1),
        hy: H - pad - ((d.hidratacion || 0) / 100) * (H - pad * 2),
        sy: H - pad - ((d.sensibilidad || 0) / 100) * (H - pad * 2),
        label: d.date?.slice(5),
    }));

    const path = (key) =>
        points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p[key]}`).join(" ");

    return (
        <div className="rounded-lg border border-line bg-card p-5 shadow-soft">
            <div className="mb-4 flex items-center justify-between">
                <h3 className="text-[16px] font-bold tracking-tight text-ink">Cómo evoluciona tu piel</h3>
                <div className="flex items-center gap-4 text-[13px] text-subtle">
                    <span className="flex items-center gap-1.5">
                        <span className="h-2 w-2 rounded-full bg-terracotta" /> Hidratación
                    </span>
                    <span className="flex items-center gap-1.5">
                        <span className="h-2 w-2 rounded-full" style={{ background: "hsl(20 5% 45%)" }} /> Sensibilidad
                    </span>
                </div>
            </div>
            <svg viewBox={`0 0 ${W} ${H}`} className="w-full" preserveAspectRatio="none" style={{ height: 200 }}>
                {[0, 25, 50, 75, 100].map((g) => {
                    const y = H - pad - (g / 100) * (H - pad * 2);
                    return <line key={g} x1={pad} y1={y} x2={W - pad} y2={y} stroke="hsl(30 10% 90%)" strokeWidth="1" />;
                })}
                <path d={path("sy")} fill="none" stroke="hsl(20 5% 45%)" strokeWidth="2" strokeLinejoin="round" />
                <path d={path("hy")} fill="none" stroke="hsl(14 45% 45%)" strokeWidth="2.5" strokeLinejoin="round" />
                {points.map((p, i) => (
                    <g key={i}>
                        <circle cx={p.x} cy={p.hy} r="4" fill="hsl(14 45% 45%)" />
                        <circle cx={p.x} cy={p.sy} r="3" fill="hsl(20 5% 45%)" />
                        <text x={p.x} y={H - 8} textAnchor="middle" fontSize="11" fill="hsl(20 5% 45%)">
                            {p.label}
                        </text>
                    </g>
                ))}
            </svg>
        </div>
    );
}
